<div class="u-shadow-mini pos-relative">
  <app-loader [showLoader]=showLoad></app-loader>
  <div class="c-portlet_box_specs">
    <div *ngIf="!hasData">
      <div class="creative-title primary-color">
        <h5>{{sectiontitle}}</h5>
      </div>
      <div class="parameters-div">
        No data found
      </div>
    </div>

    <div *ngIf="hasData">
      <div class="creative-title primary-color">
        <h5 [title]="currentCreativeData?.creativeName"> {{sectiontitle}} : {{currentCreativeData?.creativeName}}</h5>
      </div>
      <div class="parameters-div">
        <div *ngFor="let stat of currentCreativeStats" class="inline inline{{currentCreativeStats.length}}">
          <div class="param-name">{{stat.name | titlecase}}</div>
          <div class="param-val">{{stat.value}}</div>
        </div>
        <br class="clearBoth" />
      </div>
      <div class="carousel-area">
        <div class="creative-performance-stats">
          <ngu-carousel #carousel [inputs]="carouselOne" [dataSource]="sortedCreatives">
            <ngu-tile NguCarouselItem *nguCarouselDef="let creativeData;">
              <app-creative-performance-stats [creative]="creativeData"></app-creative-performance-stats>
            </ngu-tile>
            <button NguCarouselPrev class="leftRs">&lt;</button>
            <button NguCarouselNext class="rightRs">&gt;</button>
            <ul class="carousel-points-container myPoint" NguCarouselPoint>
              <li *ngFor="let j of carousel.pointNumbers; let k = index" [class.active]="j==carousel.activePoint"
                (click)="moveToSelectedCarousel(k)"></li>
            </ul>
          </ngu-carousel>
        </div>
        <div class="performance-graph-area" *ngIf="!showLoad">
          <app-creative-r5-graph [legendData]="legend" [graphData]="graphData" [name]="'creative_' + key"
          (legendSelected)="processSelectedLegendItem($event)" (mouseOutChart)="chartHover($event)"
            (mouseOverChart)="chartHover($event)"></app-creative-r5-graph>
        </div>
      </div>
    </div>
  </div>
</div>